import { componentFactory } from 'vue-tsx-support';

import { JtnUiModal } from '@jtnews/jtn-ui';
import { tsStoreMixin } from '@jtnews/shared';
import { NoServerRendering } from '@jtnews/shared/no-ssr';

const WIDTH = 620;
const WIDTH_MOBILE = 320;
const ID = 'browser-notifications-blocked-modal';

// eslint-disable-next-line @typescript-eslint/naming-convention
const NotificationsBlockedModal = () =>
  import(
    /* webpackChunkName: "browser-notifications-blocked" */ '../../browser-notifications-blocked'
  ).then(m => m.BrowserNotificationsBlocked);

export default componentFactory.mixin(tsStoreMixin).create({
  name: 'BrowserNotificationsBlockedModal',
  model: {
    prop: 'isOpen',
    event: 'changeModalState'
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobileOnly(): boolean {
      return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
    },
    width(): number {
      return this.isMobileOnly ? WIDTH_MOBILE : WIDTH;
    }
  },
  methods: {
    changeModalState() {
      this.$emit('changeModalState', !this.isOpen);
    }
  },
  render() {
    return (
      <NoServerRendering>
        <div>
          <JtnUiModal
            isOpen={this.isOpen}
            onToggle={() => this.changeModalState()}
            maxWidth={this.width}
            targetName={ID}
          >
            {this.isOpen && (
              <NotificationsBlockedModal onClosed={() => this.changeModalState()} />
            )}
          </JtnUiModal>
        </div>
      </NoServerRendering>
    );
  }
});
